export default Object.freeze({
  CONNECTING: 'connecting',
  CLOSED: 'closed',
  OPEN: 'open',
  PENDING: 'pending',
});
